// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { DEFAULT_VALUES, useLocalizedHref } from "@libraries/web-framework";
import { FormattedMessage, useIntl } from "react-intl";

import { UNSAFE_media, media } from "@atlaskit/primitives/responsive";

import HeroImageTextSide from "@/patterns/wpl/hero-image-text-side/src";

import { getHeroSectionImage } from "../localized-images";

// Styles for adding a Lifted Bar
// const adBannerContainerStyles = css`
//     margin: auto;
//     position: relative;
//     background: #091e42;
//     display: flex;
//     justify-content: center;

//     ${media.above.sm} {
//         img {
//             display: block;
//         }
//     }

//     ${media.above.md} {
//         img {
//             display: unset;
//         }
//     }
// `;

const jswHeroSectionStyle = css`
    .jsw-hero-section {
        overflow: hidden;
        padding: 110px 16px 30px;

        .row-layout {
            max-width: 1440px;
            width: auto;
            padding: 0;
        }

        .content-block {
            order: 2;
        }

        h1 {
            font-size: 2rem;
            line-height: 1.25;
            margin-bottom: 14px;
        }

        p {
            font-size: 1.25rem;
            letter-spacing: 0.3px;
            line-height: 1.4;
            margin-bottom: 24px;
        }

        h1,
        p,
        a {
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }

        .contentBlock-linkFlex {
            margin-bottom: 0;
        }

        img {
            order: 1;
            width: 100%;
            max-width: none;
        }
    }

    ${media.above.sm} {
        .jsw-hero-section {
            .row-layout {
                grid-template-columns: minmax(0, 1fr) minmax(0, 0.95fr);
                gap: 0;
            }

            .content-block {
                order: 1;
                margin-left: 16.5%;
                width: 78%;
            }

            h1 {
                font-size: 2.75rem;
                line-height: 1.18181818;
                margin-bottom: 16px;
            }

            p {
                font-size: 1.25rem;
                letter-spacing: 0.3px;
                line-height: 1.4;
                margin-bottom: 24px;
            }

            img {
                width: 850px;
                order: 2;
                align-self: baseline;
            }
        }
    }

    ${UNSAFE_media.only.sm} {
        .jsw-hero-section {
            .content-block {
                margin-left: 0;
                width: 95%;
            }

            img {
                width: 118%;
            }
        }
    }

    @media (max-width: 1300px) and (min-width: 1024px) {
        .jsw-hero-section img {
            width: 147%;
        }
    }

    ${media.above.lg} {
        .jsw-hero-section {
            .row-layout {
                padding-left: 16px;
                padding-right: 16px;
            }

            img {
                width: 850px;
            }

            h1 {
                font-size: 3rem;
                line-height: 3.5rem;
                margin-bottom: 24px;
            }

            p {
                font-size: 1.25rem;
                letter-spacing: 0.3px;
                line-height: 1.4;
            }
        }
    }
`;

const HeroSection = () => {
    const intl = useIntl();

    const localizedImageSrc = getHeroSectionImage(intl.locale);

    return (
        <section css={jswHeroSectionStyle}>
            <HeroImageTextSide
                headerText={
                    <FormattedMessage
                        id="JiraSoftwarePageTemplate.heroHeader"
                        defaultMessage="Move fast, stay aligned, and build better - together"
                        values={DEFAULT_VALUES}
                    />
                }
                bodyText={
                    <FormattedMessage
                        id="JiraSoftwarePageTemplate.heroBody"
                        defaultMessage="The #1 software development tool used by agile teams"
                        values={DEFAULT_VALUES}
                    />
                }
                ctaProps={{
                    buttonProps: {
                        text: intl.formatMessage({
                            id: "JiraSoftwarePageTemplate.heroCTA",
                            defaultMessage: "Get it free"
                        }),
                        color: "yellow",
                        url: useLocalizedHref("/software/jira/free"),
                        dataEventProps: {
                            "data-event-component": "linkButton",
                            "data-event-container": "heroSection",
                            "data-event": "clicked",
                            "data-product-key": "jiraSoftware"
                        }
                    }
                }}
                className={"jsw-hero-section"}
                // TODO: replace with locally stored asset in the repo or content platform?
                imageLink={localizedImageSrc}
                imageAltText={intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.heroImageAltText",
                    defaultMessage:
                        "Illustration demonstrating workflows in Jira Software"
                })}
                backgroundProperties={{
                    bgColor: "n700",
                    textColor: "n0",
                    bgColor2: "n900",
                    gradientDirection: "180"
                }}
                aspectRatio={"none"}
            />
            {/* To use a Lifted Bar:
            
            <div css={adBannerContainerStyles}>
                <UnleashBanner />
            </div>

             */}
        </section>
    );
};

export default HeroSection;
